<template>
  <app-widget
    actions
    class-widget="xs12"
  >
    <div slot="widget-content">
      <v-subheader
        class="font-weight-bold primary--text"
        v-text="`Emails para contato`"
      />
      <v-list v-if="array.length > 0">
        <v-list-item
          v-for="(item, i) in array"
          :key="i"
          @click="goToClipboard(item.valor)"
        >
          <v-list-item-avatar>
            <v-avatar
              :color="$options.filters.getColorToEmail(item.principal)"
              size="40"
            >
              <v-icon
                dark
              >
                {{ $options.filters.getIconToEmail(item.principal) }}
              </v-icon>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="`${item.valor}`" />
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              icon
              @click.stop="goToEdit(item.id)"
            >
              <v-icon color="warning lighten-1">
                edit
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="black lighten-2 white--text">
              thumb_down
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="'Nenhum email foi cadastrado.'" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <div slot="widget-actions">
      <v-btn
        @click="goToAdd"
        color="primary darken-3"
      >
        Adicionar email
      </v-btn>
    </div>
  </app-widget>
</template>

<script>
import AppWidget from '@/components/AppWidget'
import Store from '../store'
export default {
  name: 'AppListaEmail',
  components: {
    AppWidget
  },
  data () {
    return {
      document: null,
      array: []
    }
  },
  created () {
    this.document = Store.getters[this.$route.meta.documentAttrEmail]
    this.array = Store.getters[this.$route.meta.documentAttrEmail].emails
  },
  methods: {
    goToClipboard (message) {
      this.$copyText(message).then(() => {
        alert('E-mail enviado para a área de transferência.')
      }, () => {
        alert('Não foi possível copiar este e-mail.')
      })
    },
    goToEdit (id) {
      this.$router.push({
        name: this.$route.meta.routeToEditEmail,
        params: {
          key: this.document.id,
          id
        }
      })
    },
    goToAdd () {
      this.$router.push({
        name: this.$route.meta.routeToAddEmail,
        params: {
          key: this.document.id
        }
      })
    }
  }
}
</script>
